import React from "react"
import PropTypes from "prop-types"

const BlogAnchor = ({ href, children, ...props }) => {
  return (
    <a {...props} href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  )
}

BlogAnchor.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
}

export default BlogAnchor
